/**
 * Maps technical API error messages to user-friendly messages.
 * Use this when displaying API errors to end users (e.g. toast.error).
 *
 * @param {string} message - Raw error message from API
 * @returns {string} User-friendly error message
 */
export function toUserFriendlyMessage(message) {
  if (!message || typeof message !== "string") return "Something went wrong. Please try again.";

  const trimmed = message.trim().toLowerCase();

  // Auth / Session
  if (
    trimmed.includes("org_id") &&
    (trimmed.includes("empty") || trimmed.includes("missing")) &&
    trimmed.includes("token")
  ) {
    return "Unable to complete this action. Your session may have expired or your organization isn't set up correctly. Please try signing out and signing back in, or contact your administrator.";
  }
  if (
    trimmed.includes("authentication token") &&
    (trimmed.includes("missing") || trimmed.includes("required"))
  ) {
    return "Please sign in to continue.";
  }
  if (trimmed.includes("missing authentication token")) {
    return "Please sign in to continue.";
  }
  if (
    trimmed.includes("token") &&
    (trimmed.includes("expired") || (trimmed.includes("session") && trimmed.includes("expired")))
  ) {
    return "Your session has expired. Please sign in again.";
  }
  if (
    trimmed.includes("invalid token") ||
    trimmed.includes("token is invalid") ||
    trimmed.includes("token has expired")
  ) {
    return "Your session is invalid or has expired. Please sign in again.";
  }
  if (trimmed.includes("session is expired")) {
    return "Your session has expired. Please sign in again.";
  }

  // Org / Access
  if (
    trimmed.includes("org_id") &&
    (trimmed.includes("required") || trimmed.includes("not found"))
  ) {
    return "Your organization could not be identified. Please contact your administrator.";
  }
  if (trimmed.includes("invalid or expired subscription")) {
    return "Your subscription has expired or is inactive. Please upgrade or renew to continue.";
  }
  if (trimmed.includes("invalid organization id")) {
    return "We couldn't identify your organization. Please contact support.";
  }

  // Common API
  if (trimmed.includes("bad request")) {
    return "Please check your input and try again.";
  }
  if (trimmed.includes("failed to fetch") || trimmed.includes("network error")) {
    return "Unable to connect. Please check your internet connection and try again.";
  }
  if (trimmed.includes("internal server error") || trimmed.includes("500")) {
    return "Something went wrong on our end. Please try again in a few moments.";
  }
  if (trimmed.includes("service unavailable") || trimmed.includes("503")) {
    return "Service is temporarily unavailable. Please try again shortly.";
  }

  return message;
}
